var NCSK = NCSK || {};

NCSK.navigation = new function () {

    this.init = function () {
        shrinkMenu();
        subMenu();
    }

    // Shrink menu on scroll
    function shrinkMenu() {
        var $window = $(window),
            menu = $('nav.navbar'),
            menuHeight = menu.innerHeight();

        $window.scroll(function () {
            menu.toggleClass('shrink', $window.scrollTop() > menuHeight + 100);
        });
        $(".navbar-toggle").click(function () {
            $(".navbar-default").toggleClass("solid");
        })

    }

    function subMenu() {
        $(".sub-menu-arrow").click(function () {
            $(this).next(".dropdown-menu").stop().slideToggle();
            $(this).toggleClass("sub-menu-arrow--rotated");
        })
    }
};

